export default function AgendaCategoryController(
  $filter,
  $rootScope,
  $scope,
  $timeout,
  alerts,
  oversightDataService,
  oversightSharedModelService,
  loaderService,
) {
  const vm = this;

  // Attach Event Handlers
  vm.handleExpandAgendaCategory = _handleExpandAgendaCategory;

  _init();

  /** **********************************************
   * Event Handlers
   */

  function _handleExpandAgendaCategory() {
    if (!vm.isExpanded) {
      _loadAgendaCategoryItems().then(() => {
        vm.isExpanded = true;
      });
    } else {
      vm.isExpanded = false;
    }
  }

  /** **********************************************
   * Private Functions
   */

  function _init() {
    vm.canExpand = true;
    vm.isExpanded = false;
    vm.hasData = false;

    _initEventListeners();
  }

  function _initEventListeners() {
    $scope.$on('refreshAgendaCategories', (event, opt) => {
      if (opt.agendaCategoryId === vm.category.agendaCategoryId) {
        _loadAgendaCategoryItems(true);
      }
    });
  }

  function _setNoItemMessage() {
    if (vm.categoryItems.length === 0) {
      vm.noItemMessage = 'There are currently no Findings for you to contribute to in this Audit.';
    } else {
      vm.noItemMessage = 'There are no Findings yet. Please import or add Findings.';
    }
  }

  function _loadAgendaCategoryItems(includeSubItems = false) {
    loaderService.showViewLoader = true;
    return oversightSharedModelService.getAgendaCategoryItems(vm.category.agendaCategoryId, includeSubItems)
      .then((items) => {
        loaderService.showViewLoader = false;
        vm.categoryItems = items;
        _setNoItemMessage();
      });
  }
}

AgendaCategoryController.$inject = [
  '$filter',
  '$rootScope',
  '$scope',
  '$timeout',
  'alerts',
  'oversightDataService',
  'oversightSharedModelService',
  'loaderService',
];
